import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnpsHelpModalComponent } from './enps-help-modal.component';
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [EnpsHelpModalComponent],
  imports: [CommonModule, ButtonModule],
})
export class EnpsHelpModalModule {}
